<rt-select
  [formControl]="control()"
  [options]="locationOptions()"
  [hasInputTrigger]="true"
  [hasClearButton]="true"
  [isInvalid]="isInvalid()"
  [readOnly]="isReadOnly()"
/>
